import React from "react";
import {connect} from "react-redux";
import * as jotoTypes from "../../api/joto-types";
import * as jotoui from "../../joto-ui-api"
import {ILikeThis} from "../ILikeThis";
import {LikeCount} from "../LikeCount";
import PropTypes from "prop-types";
import {generateDummyPicture} from "../JotoUIUtils";

interface ProjectCardState {
}

interface ProjectCardProps extends ProjectCardState {
    project: jotoTypes.Project,
    jotoui: jotoui.JotoUIApi,
    fnclick?: (p: jotoTypes.Project) => void
}
// 287 x 180 px

class ProjectCard_ extends React.Component<ProjectCardProps, {}> {

    constructor(props: ProjectCardProps) {
        super(props);
        this.fnclick = this.fnclick.bind(this);
        this.fnlike = this.fnlike.bind(this);
    }

    fnclick(p : jotoTypes.Project) {
        this.props.jotoui.showProjectDetailPage(p);
    }

    fnlike() {
        this.props.jotoui.likeToggle(this.props.project);
    }

    render() {
        const spid = this.props.project.uid + '-' + this.props.project.pid;
        let fn = this.fnclick;
        if (this.props.fnclick)
            fn = this.props.fnclick;

        let pictureURL = '' + this.props.project.pictureURL;
        if(pictureURL.trim().length === 0)
            pictureURL = generateDummyPicture(this.props.project.name); // `https://dummyimage.com/287x180/F5C979/000.jpg&text=${this.props.project.name.trim()[0]}`;

        return (
            <div key={spid} className="card " id="project-card" onClick={(e) => {fn(this.props.project);}}>
                <img className="card-img-top" src={pictureURL} alt={this.props.project.name}/>
                <div className="card-body overflow-auto">
                    <h1 className="card-title">
                        <LikeCount path={this.props.project}/>
                        <ILikeThis path={this.props.project} fnlike={this.fnlike}/>
                        <br/>{this.props.project.name}
                    </h1>
                    <h2 className="card-subtitle mb-2 text-muted">{this.props.project.abstract}</h2>
                </div>
            </div>
        );
    }
}


// @ts-ignore
ProjectCard_.propTypes = {
    project: PropTypes.object.isRequired,
    jotoui: PropTypes.object.isRequired,
};


// noinspection JSUnusedLocalSymbols
const ProjectCard_mapStateToProps = (state : jotoui.JotoUIState) : ProjectCardState => ({
});

export const ProjectCard = connect(ProjectCard_mapStateToProps)(ProjectCard_);
